require('./hireCardOpenCreditError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

// @constants
const {
    KNOWN_ERROR_CODE,
    REJECTED,
    LOW_CREDIT_SCORE
} = require('constants/hireCardSubmitScenarios');
const { catalogue, analyticsId } = require('../analytics/hireCardOpenCreditAnalytics');

class HireCardOpenCreditError extends React.Component {

    handleGoToDocumentation() {
        this.props.history.push('/myprofile/documentation');
    }

    buildTexts() {
        const { immHireCardOpenCredit, hasAvailableAccounts, maxAllowedNumberCards, hireRestrictionFlag } = this.props;
        let titleKey = 'hireCardOpenCredit-errorTitleGeneric';
        let textElement = (
            <div className="hire-card-open-credit-error__text">
                <FormattedText value="hireCardOpenCredit-errorTextGeneric" />
            </div>
        );

        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardOpenCredit-errorTitleNotAvailableAccounts';
            textElement = formatText('hireCards-errorTextNotAvailableAccounts');
        }
        else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />;
        }

        switch (immHireCardOpenCredit.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = 'hireCardOpenCredit-errorTitleGeneric';
                textElement = (
                    <div>
                        <div className="hire-card-open-credit-error__text hire-card-open-credit-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${immHireCardOpenCredit.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-open-credit-error__text">
                            <FormattedText
                                value="hireCardOpenCredit-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-open-credit-error__phone">
                            <i className="hire-card-open-credit-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardOpenCredit-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = 'hireCardOpenCredit-errorTitleRejected';
                textElement = (
                    <div>
                        <div className="hire-card-open-credit-error__text">
                            <FormattedText
                                value="hireCardOpenCredit-errorTextCallUs2"
                            />
                        </div>
                        <div className="hire-card-open-credit-error__phone">
                            <i className="hire-card-open-credit-error__phone-icon icon icon-s-llamar" />
                            <FormattedText value="hireCardOpenCredit-phoneNumberClients" />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = 'hireCardOpenCredit-hireCardOpenCredit_errorTitleLowCreditScore_updated';
                const documentationLink = (
                    <a onClick={() => this.handleGoToDocumentation()} >
                        <FormattedText value="hireCardOpenCredit-documentation" />
                    </a>
                    );
                textElement = (
                    <div>
                        <div className="hire-card-open-credit-error__text hire-card-open-credit-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCardOpenCredit-hireCardOpenCredit_lowCreditScoreMessage_updated_1`}
                            />
                            {documentationLink}
                            <FormattedText
                                value={`hireCardOpenCredit-hireCardOpenCredit_lowCreditScoreMessage_updated_2`}
                            />
                        </div>
                    </div>
                );
                break;
        }

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { textElement, titleKey } = this.buildTexts();
        const { hasAvailableAccounts, maxAllowedNumberCards, processDetail, hireRestrictionFlag } = this.props
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }: hasAvailableAccounts && !maxAllowedNumberCards  ? {
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCardOpenCredit-errorBackButtonText"
                />
            ),
            url: '/myprofile/global'
        } :
        ({
            label: (
                <FormattedText
                    format="uppercase"
                    value="hireCards-backButtonLabel"
                />
            ),
            url: '/myprofile/cards'
        });
        const cancleButton ={
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionCancleButtonText"
                />
            ),
            url: '/myprofile/cards'
            };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.OPEN_CREDIT_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-card-open-credit-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

HireCardOpenCreditError.propTypes = {
    history: PropTypes.object.isRequired,
    immHireCardOpenCredit: PropTypes.object.isRequired,
    hasAvailableAccounts: PropTypes.bool,
    maxAllowedNumberCards: PropTypes.bool,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardOpenCreditError.defaultProps =
{
    hireRestrictionFlag : false
}
module.exports = withRouter(HireCardOpenCreditError);
